import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { ExternalLink, NamedLink } from '../../../../components';
import { useModal } from '../../../../services/context/ModalProvider';
import ModalFormBox from '../../../../newComponents/ContactModalForm';
import { Link } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import { FaUserGroup } from 'react-icons/fa6';

const ContactBoxSection = styled.div`
    border-radius: 8px;
    box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.07);
    padding: 38px 35px 40px;
    display: flex;
    gap: 35px;
    max-width: 630px;
    margin-top: 40px;
    .left-section {
        h3 {
            font-size: 19px;
            line-height: 27px;
            font-weight: 500;
        }
        p {
            color: ${({ theme }) => theme.colors.title_green};
            margin-top: 8px;
            font-weight: 600;
            line-height: 180%;
        }
    }
    .right-section {
        flex: 1 0 auto;
        ul {
            gap: 16px;
            li {
                gap: 8px;
                color: #6ea44c;
                a.icon {
                    gap: 8px;
                    color: #6ea44c;
                    line-height: 28px;
                    font-weight: 600;
                    &:hover {
                        color: #3d8b0d;
                    }
                }
            }
        }
    }
    @media (max-width: ${({ theme }) => theme.media.tab}) {
        width: 100%;
        padding: 16px;
        flex-wrap: wrap;
        gap: 12px;
        margin-top: 10px;
        .left-section {
            h3 {
                font-size: 17px;
                line-height: 25px;
            }
        }
        .right-section {
            ul {
                gap: 4px;
                a.icon {
                    font-size: 16px;
                    line-height: 28px;
                }
            }
        }
    }
`;

const ContactBox = () => {
    const title = <FormattedMessage id="PartnersPage.ContactAction.title" />;
    const paraTxt = <FormattedMessage id="PartnersPage.ContactAction.paragraph" />;
    const { openModal, closeModal } = useModal();

    const handleOpenDefaultForm = e => {
        // supply the form as a React element
        e.preventDefault();
        openModal(<ModalFormBox closeBtn={() => closeModal()} subjectLine={''} />);
    };
    return (
        <ContactBoxSection className="mx-auto">
            <div className="left-section">
                <h3>{title}</h3>
                <p>{paraTxt}</p>
            </div>
            <div className="right-section">
                <ul className="flex flex-col">
                    <li className="flex items-center">
                        <ExternalLink
                            href="https://calendly.com/frankhajek/30min"
                            className="icon flex items-center"
                        >
                            <FaPhoneAlt />{' '}
                            <FormattedMessage id="PartnersPage.ContactAction.phone" />
                        </ExternalLink>
                    </li>
                    <li className="flex items-center">
                        <Link onClick={handleOpenDefaultForm} className="icon flex items-center">
                            <FaEnvelope />{' '}
                            <FormattedMessage id="PartnersPage.ContactAction.email" />
                        </Link>
                    </li>
                    <li className="flex items-center">
                        <Link to="/team-up" className="icon flex items-center">
                            <FaUserGroup />
                            <FormattedMessage id="PartnersPage.ContactAction.teamUp" />
                        </Link>
                    </li>
                </ul>
            </div>
        </ContactBoxSection>
    );
};

export default ContactBox;
